// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__S_XJX","emojiWrapper":"styles_emojiWrapper__A0Pi2"};